<template lang="pug">
v-dialog#tax-dialog(v-model="value", scrollable, persistent, max-width=640, eager)
  v-card 
    v-card-title 
      .title {{ editType == 1 ? $t('Taxes.__AddTax') : $t('Taxes.__EditTax') }}
    v-card-text
      v-form(v-model="formValid", ref="taxform")
        .field-label 
          span {{ $t('Taxes.__TaxName') }}
          span.required *
        v-text-field(v-model="item.name", solo, dense, outlined, required, :rules="[rules.required]")
        .field-label 
          span {{ $t('Taxes.__TaxAbbr') }}
          span.required *
        v-text-field(v-model="item.abbreviation", solo, dense, outlined, :rules="[rules.required]")
        .field-label 
          span {{ $t('Taxes.__TaxDescription') }}
        v-textarea(v-model="item.description", solo, outlined, height="80")
        //- .field-label 
        //-     span identificationNumber
        //- v-text-field(v-model="item.identificationNumber" solo dense outlined  )
        .field-label 
          span {{ $t('Taxes.__TaxRate') }}
          span.required *
        v-text-field(
          v-model.number="item.rate",
          type="number",
          solo,
          dense,
          outlined,
          required,
          :rules="[rules.required, rules.rateRange]",
          :disabled="editType != 1",
          :placeholder="$t('Taxes.__RatePlaceholder')"
        )
        .notice.primary--text {{ $t('Taxes.__RateNote') }}

    v-card-actions.justify-center.mb-6
      v-btn.mr-6(rounded, dark, @click="cancelEditDialog", color="lightGray", width="112") {{ $t('ActionOption.__Cancel') }}
      v-btn(rounded, dark, @click="saveEdit", color="primary", width="112") {{ $t('ActionOption.__Save') }}
</template>

<script>
import * as textfieldUtils from "@/utils/textfield.js"

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    editType: {
      type: Number,
      default: 1
    },
    item: {
      type: Object,
      default: function() {
        return {}
      }
    },
    doneAction: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      formValid: false,
      rules: textfieldUtils.rules
    }
  },
  methods: {
    saveEdit() {
      this.$refs.taxform.validate()
      if (this.formValid) {
        if (this.editType == 1) {
          this.createTax()
        } else {
          this.updateTax()
        }
      }
    },
    createTax() {
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("taxes/createTax", this.item)
        .then(
          function(response) {
            this.doneAction(response.data.taxId)

            this.$store.dispatch("global/showAlertSuccess", this.$t("Messages.__SuccessfullyCreated"))
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/showAlertError", error.message)
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
      this.cancelEditDialog()
    },
    updateTax() {
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("taxes/updateTax", this.item)
        .then(
          function(response) {
            this.doneAction()
            this.$store.dispatch("global/showAlertSuccess", this.$t("Messages.__SuccessfullyUpdated"))
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/showAlertError", error.message)
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
      this.cancelEditDialog()
    },
    cancelEditDialog() {
      this.$emit("input", false)
      this.$refs.taxform.resetValidation()
      this.$refs.taxform.reset()
    }
  }
}
</script>
